// extracted by mini-css-extract-plugin
export var cartContainer = "_px-4";
export var gray = "_px-1";
export var itemContainer = "_px-2";
export var itemDetails = "_px-3";
export var strong = "_px-0";